import React from "react";
// svg of icon in nav to close
export const NavClosedIcon = () => {
  return (
    <>
      <svg
        className="block h-6 w-6 text-black"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </>
  );
};
